<aside>
  <hm-nav></hm-nav>
</aside>
<main>
  <router-outlet></router-outlet>
</main>

<hm-page-spinner></hm-page-spinner>
